import React, {
  ReactNode,
  cloneElement,
  createContext,
  useContext,
  useState,
  Dispatch,
  SetStateAction,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Modal as AntModal, ModalProps } from "antd";

interface Props {
  children?: ReactNode;
}
interface OpenProps {
  children: JSX.Element;
  opens?: string;
}
interface WindowProps extends ModalProps {
  children: JSX.Element;
  name?: string;
}

const ModalContext = createContext<{
  openName: string;
  open: Dispatch<SetStateAction<string>>;
  close: () => void;
}>({ openName: "", close: () => {}, open: () => {} });

export const Modal = ({ children }: Props) => {
  const [openName, setOpenName] = useState<string>("");

  const open = setOpenName;
  const close = () => setOpenName("");

  return (
    <ModalContext.Provider value={{ openName, open, close }}>
      {children}
    </ModalContext.Provider>
  );
};

const Open = forwardRef(
  ({ children, opens: opensWindowName }: OpenProps, ref) => {
    const { open } = useContext(ModalContext);

    const onOpen = () => {
      open(opensWindowName || "");
    };

    useImperativeHandle(ref, () => ({ onOpen }));

    return cloneElement(children, { onClick: onOpen });
  }
);

const Window = ({ name, children, ...restProps }: WindowProps) => {
  const { openName, close } = useContext(ModalContext);

  return (
    <AntModal
      destroyOnClose
      closable={false}
      open={name === openName}
      onCancel={close}
      footer={null}
      {...restProps}
    >
      {cloneElement(children, { onCloseModal: close })}
    </AntModal>
  );
};

Modal.Open = Open;
Modal.Window = Window;
